import { render, staticRenderFns } from "./DistributorRightsAndObligationsOutput.vue?vue&type=template&id=4414739a&"
import script from "./DistributorRightsAndObligationsOutput.vue?vue&type=script&lang=js&"
export * from "./DistributorRightsAndObligationsOutput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/apps/eneforhandler/components/contract/DistributorRightsAndObligationsOutput.vue
// module id = null
// module chunks = 